const indexedPaths = {
  "fastqrgenerator.com": ["/", "/contact-us"],
  "qrcreator.com": ["/", "/contact-us"],
  "onlineqrcode.com": [],
  "app.onlineqrcode.com": [],
  "qrnow.com": ["/pricing"],
  "app.qrnow.com": ["/pricing"],
};

module.exports = {
  indexedPaths,
};
